// extracted by mini-css-extract-plugin
export var aggregationCell = "_2d-n";
export var aggregationRow = "_2d-m";
export var borderlessSpinnerContainer = "_2d-3";
export var cardLayout = "_2d-6";
export var cardLayoutNoFooter = "_2d-9";
export var cardLayoutPageControl = "_2d-8";
export var closeIcon = "_2d-f";
export var columnHeaderSurface = "_2d-b";
export var columnHeaderSurfaceDragOverlay = "_2d-v";
export var columnHeaderSurfaceResizing = "_2d-s";
export var contextMenuAnchor = "_2d-1";
export var draggableColumnHeader = "_2d-t";
export var draggableColumnHeaderOverlay = "_2d-u";
export var expandIcon = "_2d-g";
export var expanded = "_2d-h";
export var filterDropdown = "_2d-i";
export var filterDropdownDivider = "_2d-d";
export var filterDropdownHeader = "_2d-l";
export var filterDropdownItem = "_2d-k";
export var filterDropdownModal = "_2d-j _2d-i";
export var filterItem = "_2d-c";
export var normalCellWithAdjustableBorder = "_2d-e";
export var pinButtonContainer = "_2d-o";
export var pinIcon = "_2d-p";
export var pinIconActive = "_2d-q";
export var spinner = "_2d-0";
export var spinnerContainer = "_2d-2";
export var tableContainer = "_2d-4";
export var tableContentDraggingColumns = "_2d-a";
export var tableContentInner = "_2d-7";
export var tableContentWrapper = "_2d-5";
export var viewButtonContainer = "_2d-r";